import http from '../../utils/fetch';
import updownfile from "../../utils/updownfile";
export default {

    baseurl:'/api/swyl/v1/zulincesuan/rateFormulaZulincesuan',
    zulinshiti:'/api/swyl/v1/zulinshiti/rateFormulaZulinshiti',




    zulindownloadExcel(c){

        updownfile.down(this.zulinshiti+'/downloadExcel',c,"post",'data');

    },


    //获取定价
    huoqudingjia(query){
        return http({
            url: this.baseurl+'/huoqudingjia',
            method: 'post',
            params: query
        });
    },


    //获取user
    getusershiti(query){
        return http({
            url: this.zulinshiti+'/getusershiti',
            method: 'post',
            params: query
        });
    },




    zulinshitiselectPage(query){
        return http({
            url: this.zulinshiti+'/selectPage',
            method: 'post',
            params: query
        });
    },


    huoqujibenjine(query){
        return http({
            url: this.zulinshiti+'/huoqujichuxinxi',
            method: 'post',
            params: query
        });
    },

    baocunxinxi(query){
        return http({
            url: this.zulinshiti+'/insert',
            method: 'post',
            params: query
        });
    },

    wanchengshenpi(query){
        return http({
            url: this.zulinshiti+'/wanchengshenpi',
            method: 'post',
            params: query
        });
    },

    chongxintijiao(query){
        return http({
            url: this.zulinshiti+'/chongxintijiao',
            method: 'post',
            params: query
        });
    },




}